import Sidebar from '../../../_layouts/admin/Sidebar';
import Topbar from '../../../_layouts/admin/Topbar';
import Foot from '../../../_layouts/admin/Foot';
import axios from 'axios';
import { useEffect, useState } from 'react';
import DataTable from "react-data-table-component";
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../../../Main';
import { handleDelete } from '../../../../utils/handleDelete';

const Product = (props) => {
  const [loading, setLoading] = useState(true);
  const [productlist, setProductlist] = useState([]);   // always array
  const [totalRows, setTotalRows] = useState(0);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  // Fetch paginated data
  const fetchProducts = async (pageNum = 1, searchTerm = search) => {
    setLoading(true);

    const res = await axios.get("/api/product", {
      params: {
        page: pageNum,
        search: searchTerm,
      },
    });

    if (res.status === 200) {
      setProductlist(res.data.product.data);
      setTotalRows(res.data.product.total);
    }
    setLoading(false);
  };

  const customStyles = {
    headCells: {
      style: {
        fontSize: '14px',   // increase size
        fontWeight: '700',  // make bold
      },
    },
  };

  const progressComponent = (
    <div style={{ padding: '20px' }}>
      <span className="spinner-border spinner-border-md" />
    </div>
  );

  const columns = [
    {
      name: "S/N",
      cell: (row, index) => (page - 1) * 10 + (index + 1),
      width: "80px",
    },
    {
      name: "Image",
      cell: row => (
        <img
          src={`${API_BASE_URL}/${row.product_image}`}
          width="40"
          alt={row.product}
        />
      ),
    },
    {
      name: "Product",
      selector: row => row.product,
      sortable: true,
    },
    {
      name: "Price",
      selector: row => `₦${Number(row.price).toLocaleString("en-NG")}`,
      sortable: true,
    },
    {
      name: "Action",
      cell: row => (
        <>
          <Link to={`/admin/product-detail/${row.slug}`}>
            <i className="fa fa-microscope text-success"></i>
          </Link>
          &nbsp;&nbsp;

          <Link to={`/admin/edit-product/${row.slug}`}>
            <i className="fa fa-edit text-primary"></i>
          </Link>
          &nbsp;&nbsp;

          <button
            onClick={() => deleteProduct(row.slug)}
            className="border-0 bg-transparent"
          >
            <i className="fa fa-trash text-danger"></i>
          </button>
        </>
      ),
    },
  ];

  useEffect(() => {
    setPage(1);
    fetchProducts(1, search);
  }, [search]);

  useEffect(() => {
    document.title = `Products - ${props.company}`;
    fetchProducts(page);
  }, [page]);


  const deleteProduct = (slug) => {
    handleDelete(`/api/delete-product/${slug}`, () => {
      // remove from state after success
      setProductlist((prev) => prev.filter((item) => item.slug !== slug));
    });
  };

  return (
    <>
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <Topbar />

          <div className="container">
            <div className="page-inner">
              <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                <div>
                  <h3 className="fw-bold mb-3">{props.page}</h3>
                </div>
                <div className="ms-md-auto py-2 py-md-0">
                  <Link to="/admin/add-product" className="btn btn-primary btn-round">
                    {props.btnAdd}
                  </Link>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">                      
                  <div className="card">   
                    <div className="card-body">

                      <div className="mb-1 d-flex justify-content-end">
                        <input
                          type="text"
                          className="form-control w-25"
                          placeholder="Search products ..."
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                        />
                      </div>

                      <DataTable
                        columns={columns}
                        data={productlist}
                        customStyles={customStyles}
                        progressPending={loading}
                        progressComponent={progressComponent}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={10}
                        onChangePage={page => setPage(page)}
                        highlightOnHover
                        responsive
                      />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Foot />
        </div>
      </div>
    </>
  );
};
export default Product;